import { render, staticRenderFns } from "./Default.layout.vue?vue&type=template&id=6c0ae5c3&lang=pug&"
import script from "./Default.layout.vue?vue&type=script&lang=ts&"
export * from "./Default.layout.vue?vue&type=script&lang=ts&"
import style0 from "./Default.layout.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports